import React, { useState } from "react";
import { IoIosCloseCircle, IoMdAdd } from "react-icons/io";
import styled from "styled-components";
import { FormControl, Select, MenuItem } from "@mui/material";
import { IoCloseCircle, IoCloseSharp } from "react-icons/io5";
import { Notify } from "../../../../../utils";
import WarningMessage from "../../../../../components/WarningMessage";

const LeaveGroupBlock = (props: any) => {
  const [showAddGroup, setShowAddGroup] = useState(false);
  const [selectedType, setSelectedType] = useState(
    props.approverType || "single"
  );
  const [selectedApprover, setSelectedApprover] = useState("");
  const [selectedSubmitter, setSelectedSubmitter] = useState("");
  

  const [showAddSubmitter, setShowAddSubmitter] = useState(false);
  const [showAddApprover, setShowAddApprover] = useState(false);

  console.log("Selected Type:", selectedType);

  const employees = [
    { id: 1, name: "Alice" },
    { id: 2, name: "Bob" },
    { id: 3, name: "Charlie" },
    { id: 4, name: "Diana" },
    { id: 5, name: "Eve" },
  ];

  const approversList = [
    {
      id: 367,
      name: "ADAM SON",
    },
    {
      id: 367,
      name: "ADAM SON",
    },
    {
      id: 367,
      name: "ADAM SON",
    },
  ];

  {
    /* Approver */
  }
  return (
    <Card selectedGroupId={props.selectedGroupId} groupId={props.group.customId}>
      <IoCloseCircle
        size={24}
        style={{
          position: "absolute",
          top: 10,
          right: 10,
          cursor: "pointer",
          color: "#FF8282",
        }}
        onClick={() => props.onRemoveGroup(props.group)}
      />

      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "0.5rem",
          gap: "1rem",
        }}
      >
        <p>Requests will be approved by: </p>
        <FormControl variant="outlined" size="small">
          <Select
            defaultValue="all"
            sx={{
              minWidth: 120,
              "& .MuiOutlinedInput-root": {
                borderRadius: "4px",
              },
            }}
            value={selectedType}
            onChange={(e) => {
              props.onClearApprovers();
              props.onApproverTypeChange(e.target.value);
              setSelectedType(e.target.value);
            }}
          >
            <MenuItem value="single">Single Approver</MenuItem>
            <MenuItem value="any">Any of the Approvers</MenuItem>
            {/* <MenuItem value="all">All Approvers</MenuItem>
            <MenuItem value="order">All Approvers in order</MenuItem> */}
          </Select>
        </FormControl>
      </div>

      {
        showAddApprover && !props.employees?.length && <WarningMessage message="No employees of this company have access to this module." />
      }

      <div style={{ marginBottom: "1rem" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            marginBottom: "0.5rem",
          }}
        >
          <AddButton onClick={() => setShowAddApprover(!showAddApprover)}>
            <IoMdAdd size={24} style={{ color: "#fff" }} />
          </AddButton>

          {showAddApprover && (
            <div
              style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
            >
              <FormControl variant="outlined" size="small">
                <Select
                  displayEmpty
                  sx={{
                    minWidth: 200,
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "4px",
                    },
                  }}
                  defaultValue=""
                  value={selectedApprover}
                  onChange={(e) => setSelectedApprover(e.target.value)}
                >
                  <MenuItem value="" disabled>
                    Select employee
                  </MenuItem>
                  
                    {props.employees
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((employee, index) => (
                    <MenuItem key={index} value={employee.id} disabled={
                      props.approversList.some(
                      (approver: any) => approver.id === employee.id
                      )}>
                      {employee.name}
                    </MenuItem>
                    ))}
                </Select>
              </FormControl>
              <ActionButton
                onClick={() => {
                  console.log("selectedType:", selectedType);
                  if (selectedType === "single" && props.approversList.length == 0) {
                    props.onAddApprover(
                      props.employees?.find((emp) => emp.id === selectedApprover)
                    );
                  } else if (selectedType === "any") {
                    props.onAddApprover(
                      props.employees?.find((emp) => emp.id === selectedApprover)
                    );
                  } else {
                    Notify("In case of 'Single Approver', only one approver can be added.", 0);
                  }

                  setSelectedApprover("");
                }}
                disabled={!selectedApprover}
              >
                Add
              </ActionButton>
              <ActionButton
                onClick={() => setShowAddApprover(false)}
                disabled={!selectedApprover}
                // variant="delete"
              >
                Done
              </ActionButton>
            </div>
          )}
        </div>

        <div
          style={{
            flexGrow: 1,
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "0.75rem",
          }}
        >
          {props.approversList && props.approversList.length > 0 ? (
            props.approversList.map((approver: any, index: number) => (
              <ApproverCard key={approver.id}>
                <IoIosCloseCircle
                  size={22}
                  style={{
                    position: "absolute",
                    top: -10,
                    right: -10,
                    cursor: "pointer",
                    color: "#FF8282",
                  }}
                  onClick={() => props.onRemoveApprover(approver.id)}
                />
                <ApproverName>{approver.name}</ApproverName>
              </ApproverCard>
            ))
          ) : (
            <p
              style={{
                color: "#6b7280",
                fontStyle: "italic",
                marginTop: "0.5rem",
                padding: "0.5rem 0rem",
              }}
            >
              Please add Approver
            </p>
          )}
        </div>
      </div>

      {/*  Submitter Block */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "0.5rem",
          gap: "1rem",
          marginTop: "1.5rem",
        }}
      >
        <p>Requests will be submitted by: </p>
      </div>

      {
        showAddSubmitter && !props.employees?.length && <WarningMessage message="No employees of this company have access to this module." />
      }

      <div style={{ marginBottom: "1rem" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            marginBottom: "0.5rem",
          }}
        >
          <AddButton onClick={() => setShowAddSubmitter(!showAddSubmitter)}>
            <IoMdAdd size={24} style={{ color: "#fff" }} />
          </AddButton>

          {showAddSubmitter && (
            <div
              style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
            >
              <FormControl variant="outlined" size="small">
                <Select
                  displayEmpty
                  sx={{
                    minWidth: 200,
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "4px",
                    },
                  }}
                  defaultValue=""
                  value={selectedSubmitter}
                  onChange={(e) => setSelectedSubmitter(e.target.value)}
                >
                  <MenuItem value="" disabled>
                    Select employee
                  </MenuItem>
                  
                  {props.employees.map((employee, index) => (
                   !props.allSubmitters.includes(employee.id) && <MenuItem key={index} value={employee.id}>
                      {employee.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <ActionButton
                onClick={() => {
                  props.onAddSubmitter(
                    props.employees?.find((emp) => emp.id === selectedSubmitter)
                  )
                  setSelectedSubmitter("");
                }}
                disabled={!selectedSubmitter}
              >
                Add
              </ActionButton>
              <ActionButton
                onClick={() => setShowAddSubmitter(false)}
                disabled={!selectedSubmitter}
                // variant="delete"
              >
                Done
              </ActionButton>
            </div>
          )}
        </div>

        <div
          style={{
            flexGrow: 1,
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "0.75rem",
          }}
        >
          {props.submittersList && props.submittersList.length > 0 ? (
            props.submittersList.map((submitter: any, index: number) => (
              <ApproverCard key={submitter.id}>
                <IoIosCloseCircle
                  size={22}
                  style={{
                    position: "absolute",
                    top: -10,
                    right: -10,
                    cursor: "pointer",
                    color: "#FF8282",
                  }}
                  onClick={() => props.onRemoveSubmitter(submitter.id)}
                />
                <ApproverName>{submitter.name}</ApproverName>
              </ApproverCard>
            ))
          ) : (
            <p
              style={{
                color: "#6b7280",
                fontStyle: "italic",
                marginTop: "0.5rem",
                padding: "0.5rem 0rem",
              }}
            >
              Please add Submitters
            </p>
          )}
        </div>
      </div>
    </Card>
  );
};

export default LeaveGroupBlock;
const AddButton = styled.div`
  display: flex;
  align-items: center;
  background-color: #a5b4fc;
  padding: 0.5rem;
  border-radius: 4px;
  cursor: pointer;
  margin: 0.5rem 0;
  margin-right: 1rem;
  transition: background-color 0.2s ease;
  width: fit-content;

  &:hover {
    background-color: #818cf8;
  }
`;

const InputField = styled.input`
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 200px;
  font-size: 1rem;
  outline: none;
  transition: border-color 0.2s ease;

  &:focus {
    border-color: #a5b4fc;
  }
`;

const ActionButton = styled.button<{ variant?: string; color?: string }>`
  padding: 0.5rem 0.75rem;
  border: 1px solid ${(props) => props.color || "#3396D3"};
  border-radius: 4px;
  background-color: transparent;
  color: ${(props) => props.color || "#3396D3"};
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${(props) => props.color || "#3396D3"};
    color: #fff;
  }
  
  &:disabled {
    border-color: #d1d5db;
    color: #d1d5db;
    cursor: not-allowed;
    
    &:hover {
      background-color: transparent;
      color: #d1d5db;
    }
  }
`;

const ApproverCard = styled.div`
  position: relative;
  background-color: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 0.5rem 1rem;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  width: fit-content;
`;

const DeleteButton = styled.button`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background: none;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
  color: #6b7280;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: color 0.2s ease;

  &:hover {
    color: #f87171;
  }
`;

const ApproverName = styled.span`
  font-weight: 500;
  color: #374151;
`;

const Card = styled.div<{ selectedGroupId?: string; groupId?: string }>`
  padding: 1rem;
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 1rem;
  /* border: 1px solid #eee; */
  position: relative;
  border: ${props => (props.selectedGroupId === props.groupId) ? '1.5px solid #D84040' : '1px solid #eee'};
  transition: all 0.2s ease;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  
  &:hover {
    border-color: #151515;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
    /* transform: translateY(-2px); */
  }
`;
